import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import { GetAllUsersPayload } from "type/users";

export const getAllUsers = createApi({
  reducerPath: "getAllUsers",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAllUsers: builder.query<any, GetAllUsersPayload>({
      query: ({ find = "", page = "", size = "", sortBy = "" }) => {
        const params = new URLSearchParams({
          find,
          page: page.toString(),
          size: size.toString(),
          sortBy,
        });

        return {
          url: `/orgUsers?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    getUserbyId: builder.query<any, any>({
      query: ({ id }) => ({
        url: `user/fetch/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllUsersQuery, useGetUserbyIdQuery } = getAllUsers;
